import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetServiceRunsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  orderBy?: Types.InputMaybe<Array<Types.Mobility_Runs_Order_By> | Types.Mobility_Runs_Order_By>;
  additionalFilters?: Types.InputMaybe<Array<Types.Mobility_Runs_Bool_Exp> | Types.Mobility_Runs_Bool_Exp>;
}>;


export type GetServiceRunsQuery = { __typename?: 'query_root', mobility_runs: Array<{ __typename?: 'mobility_runs', id: number, status: string, departure_time?: string | null, dispatched_at?: string | null, completed_at?: string | null, created_at: string, estimated_distance_miles?: number | null, config: object, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', display_name: string, avatar_url?: string | null } | null } | null, vehicle?: { __typename?: 'mobility_vehicles', id: number, make: string, model: string, year?: number | null, license_plate?: string | null } | null, stops_aggregate: { __typename?: 'mobility_stops_aggregate', aggregate?: { __typename?: 'mobility_stops_aggregate_fields', count: number } | null }, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, status: string, service_stop_detail: Array<{ __typename?: 'service_stop_details', customer_name?: string | null, estimated_service_minutes?: number | null }> }> }>, mobility_runs_aggregate: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null } };


export const GetServiceRunsDocument = gql`
    query getServiceRuns($customerId: bigint!, $limit: Int!, $offset: Int!, $orderBy: [mobility_runs_order_by!], $additionalFilters: [mobility_runs_bool_exp!]) {
  mobility_runs(
    where: {_and: [{customer_id: {_eq: $customerId}}, {product_type: {_eq: "mobile_service"}}, {_and: $additionalFilters}]}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    status
    departure_time
    dispatched_at
    completed_at
    created_at
    estimated_distance_miles
    config
    driver {
      id
      user {
        display_name
        avatar_url
      }
    }
    vehicle {
      id
      make
      model
      year
      license_plate
    }
    stops_aggregate {
      aggregate {
        count
      }
    }
    stops(order_by: {stop_order: asc}) {
      id
      stop_order
      status
      service_stop_detail {
        customer_name
        estimated_service_minutes
      }
    }
  }
  mobility_runs_aggregate(
    where: {_and: [{customer_id: {_eq: $customerId}}, {product_type: {_eq: "mobile_service"}}, {_and: $additionalFilters}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetServiceRunsQuery__
 *
 * To run a query within a React component, call `useGetServiceRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRunsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      additionalFilters: // value for 'additionalFilters'
 *   },
 * });
 */
export function useGetServiceRunsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceRunsQuery, GetServiceRunsQueryVariables> & ({ variables: GetServiceRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceRunsQuery, GetServiceRunsQueryVariables>(GetServiceRunsDocument, options);
      }
export function useGetServiceRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRunsQuery, GetServiceRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceRunsQuery, GetServiceRunsQueryVariables>(GetServiceRunsDocument, options);
        }
// @ts-ignore
export function useGetServiceRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceRunsQuery, GetServiceRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRunsQuery, GetServiceRunsQueryVariables>;
export function useGetServiceRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRunsQuery, GetServiceRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRunsQuery | undefined, GetServiceRunsQueryVariables>;
export function useGetServiceRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRunsQuery, GetServiceRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceRunsQuery, GetServiceRunsQueryVariables>(GetServiceRunsDocument, options);
        }
export type GetServiceRunsQueryHookResult = ReturnType<typeof useGetServiceRunsQuery>;
export type GetServiceRunsLazyQueryHookResult = ReturnType<typeof useGetServiceRunsLazyQuery>;
export type GetServiceRunsSuspenseQueryHookResult = ReturnType<typeof useGetServiceRunsSuspenseQuery>;
export type GetServiceRunsQueryResult = Apollo.QueryResult<GetServiceRunsQuery, GetServiceRunsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (mobility_runs, mobility_runs_aggregate): returns the full response object.
 * @source {@link src/features/mobileService/queries/getServiceRuns.query.gql}
 */
export async function getServiceRuns(
  variables: GetServiceRunsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetServiceRunsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetServiceRunsQuery>(
    GetServiceRunsDocument,
    variables,
    requestOptions
  )
}